/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoLevelUpLogListLevelUpLogData model module.
 * @module model/LogControllerDtoLevelUpLogListLevelUpLogData
 * @version 1.0
 */
class LogControllerDtoLevelUpLogListLevelUpLogData {
    /**
     * Constructs a new <code>LogControllerDtoLevelUpLogListLevelUpLogData</code>.
     * @alias module:model/LogControllerDtoLevelUpLogListLevelUpLogData
     */
    constructor() { 
        
        LogControllerDtoLevelUpLogListLevelUpLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoLevelUpLogListLevelUpLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoLevelUpLogListLevelUpLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoLevelUpLogListLevelUpLogData} The populated <code>LogControllerDtoLevelUpLogListLevelUpLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoLevelUpLogListLevelUpLogData();

            if (data.hasOwnProperty('nftLevelingNo')) {
                obj['nftLevelingNo'] = ApiClient.convertToType(data['nftLevelingNo'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('levelingTransactionNo')) {
                obj['levelingTransactionNo'] = ApiClient.convertToType(data['levelingTransactionNo'], 'Number');
            }
            if (data.hasOwnProperty('instantLevelingTransactionNo')) {
                obj['instantLevelingTransactionNo'] = ApiClient.convertToType(data['instantLevelingTransactionNo'], 'Number');
            }
            if (data.hasOwnProperty('timeToLevelUp')) {
                obj['timeToLevelUp'] = ApiClient.convertToType(data['timeToLevelUp'], 'Date');
            }
            if (data.hasOwnProperty('beforeLevel')) {
                obj['beforeLevel'] = ApiClient.convertToType(data['beforeLevel'], 'Number');
            }
            if (data.hasOwnProperty('afterLevel')) {
                obj['afterLevel'] = ApiClient.convertToType(data['afterLevel'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoLevelUpLogListLevelUpLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoLevelUpLogListLevelUpLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} nftLevelingNo
 */
LogControllerDtoLevelUpLogListLevelUpLogData.prototype['nftLevelingNo'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoLevelUpLogListLevelUpLogData.prototype['nftUid'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoLevelUpLogListLevelUpLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoLevelUpLogListLevelUpLogData.prototype['email'] = undefined;

/**
 * @member {Number} status
 */
LogControllerDtoLevelUpLogListLevelUpLogData.prototype['status'] = undefined;

/**
 * @member {Number} levelingTransactionNo
 */
LogControllerDtoLevelUpLogListLevelUpLogData.prototype['levelingTransactionNo'] = undefined;

/**
 * @member {Number} instantLevelingTransactionNo
 */
LogControllerDtoLevelUpLogListLevelUpLogData.prototype['instantLevelingTransactionNo'] = undefined;

/**
 * @member {Date} timeToLevelUp
 */
LogControllerDtoLevelUpLogListLevelUpLogData.prototype['timeToLevelUp'] = undefined;

/**
 * @member {Number} beforeLevel
 */
LogControllerDtoLevelUpLogListLevelUpLogData.prototype['beforeLevel'] = undefined;

/**
 * @member {Number} afterLevel
 */
LogControllerDtoLevelUpLogListLevelUpLogData.prototype['afterLevel'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoLevelUpLogListLevelUpLogData.prototype['createdAt'] = undefined;

/**
 * @member {Date} updatedAt
 */
LogControllerDtoLevelUpLogListLevelUpLogData.prototype['updatedAt'] = undefined;






export default LogControllerDtoLevelUpLogListLevelUpLogData;

